module.exports = __webpack_public_path__ + "static/media/logo-white.eec7c7f6.svg";